"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRut = void 0;
var useRut_1 = require("./useRut");
Object.defineProperty(exports, "useRut", { enumerable: true, get: function () { return __importDefault(useRut_1).default; } });
//# sourceMappingURL=index.js.map